export const meta = {
  title: 'MOVEMENT IS THE LAST MOAT',
  author: 'Andrew Carr',
  category: 'kinetic-age',
  date: '2026-02-11',
  slug: 'kinetic-age',
};

<ArticleVideo cdnKey="move-moat-assets-03.mp4" />

We have spent the last decade teaching sand to think. We succeeded. We built gods in boxes—LLMs that can pass the Bar Exam and write poetry; they can get a perfect score on the hardest competitive math exams and give expert medical diagnosis.

> Can I get a high five?! No?

But even the most advanced AIs can't do the movements that a 9 month old can. People learn to move and communicate long before they learn written or spoken language.

AIs are paralyzed. They are brains in jars, hallucinating worlds they cannot inhabit.

The "Text Era" of AI is over. The scraping is done. The marginal utility of the next trillion text tokens is collapsing. The market is looking for the next growth curve in the wrong place. They are trying to make the brain bigger. They should be building the body.

A body grounds a brain in the world around it. Senses connect intelligence to reality.

But what's overlooked is that a body that doesn't move is dead. Movement is the most fundamental aspect of life. And it all begins with a moving heart.

So, how do you build the body? You can make a tin man, but how do you make his heart? How do you move him?

It starts with humanity.

Lucky for us, we've been recording humans being humans, for billions of hours, and it's on the internet.

Most of the internet is not text. It is video. Video of humans in motion. Yet we treat video as "content" to be consumed rather than "data" to be mined. Kinetic data. This is a category error. Video is so much more than its transcript. Every YouTube upload, every Twitch stream, every home movie is a rigorous physics dataset. It is a record of how intelligence navigates 3D space. It contains the micro-signals of human interaction; the pause before a laugh, the shift in posture during an argument, the walk of a lost soul.

This is Dark Matter for AI. It constitutes 90% of human expression, yet current models possess 0% of it. We are sitting on the largest unrefined resource in human history, and we are treating it like noise.

Conversation is a kinetic act. Being human is a kinetic act. It is a dance of turn-taking, eye contact, and non-verbal cues. We learn to walk long before we learn to speak. That movement is fundamental to our being human.

You cannot train a model to "feel" human using text. You need tens of thousands of hours of conversational movement. We are not just building better assets; we are crossing the uncanny valley — appreciating the "umms" and "ahhs" of physical movement. This is the difference between a chatbot and a digital soul.

The first wave is well under way, it's given us a mind.

The second wave is just beginning, and it's moving… fast.

Welcome to the Kinetic Age.
